import { useEffect, useState } from "react";

type NoticeTone = "error" | "success";

function inferTone(message: string): NoticeTone {
  return /已|成功|完成/.test(message) ? "success" : "error";
}

export function AdminFormNotice({ message, tone }: { message: string; tone?: NoticeTone }) {
  const [showFloatingNotice, setShowFloatingNotice] = useState(false);

  useEffect(() => {
    if (!message) return;
    setShowFloatingNotice(true);
    const timer = window.setTimeout(() => setShowFloatingNotice(false), 5000);
    return () => window.clearTimeout(timer);
  }, [message]);

  if (!message) return null;

  const noticeTone = tone ?? inferTone(message);
  const toneClass =
    noticeTone === "success"
      ? "border-[#bfe0cb] bg-[#e9f4ec] text-[#245438]"
      : "border-[#f2b8b5] bg-[#fdebea] text-[#8a1f1f]";

  return (
    <>
      <div className={`mb-4 scroll-mt-36 rounded-md border px-4 py-3 text-sm font-medium ${toneClass}`} role="alert">
        {message}
      </div>
      {showFloatingNotice && (
        <div className={`fixed right-4 top-24 z-[80] w-[min(420px,calc(100vw-32px))] rounded-md border px-4 py-3 text-sm font-bold shadow-[0_16px_44px_rgba(32,61,50,.18)] md:top-32 ${toneClass}`} role="alert">
          {message}
        </div>
      )}
    </>
  );
}
